import React from 'react';

export interface SelectOption {
    value: string | number;
    name: string | undefined;
		key?: string;
}

export interface SelectProps {
    label: string;
    id?: string;
    defaultOption?: string;
    options?: SelectOption[];
    name: string;
    value?: string;
    register: any;
    validation?: any;
}

export const Select = ({
    label,
    id,
    defaultOption,
    options,
    name,
    register,
    validation,
    value = '',
}: SelectProps) => {
    const hasValue = typeof value === 'string' && value !== '';
    return (
        <div className="c-select form__item select--boxed">
            <div className="select__wrapper">
                <label className="select__label" htmlFor={id}>
                    {label}
                </label>
                <div className="select__input-wrapper">
                    <select
                        id={id}
                        className="select__input"
                        name={name}
                        {...register(name, validation ? validation : {})}
                        defaultValue={value}>
                        {defaultOption && !hasValue && (
                            <option value={defaultOption} disabled>
                                {defaultOption}
                            </option>
                        )}

                        {options &&
                            options.map((option) => (
                                <option value={option.value} key={(option?.key) ? option.key : option.value}>
                                    {option.name}
                                </option>
                            ))}
                    </select>
									{/*
									<div className="select__icon">
										<ArrowDown width={13} height={8} />
									</div>
									*/}
                </div>
            </div>
        </div>
    );
};
